import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/vehiclePackages',
  component: LAYOUT,
  name: 'vehiclePackages',
  redirect: '/vehiclePackages/index',
  meta: {
    title: '流量查询',
  },
  children: [
    {
      path: 'index',
      name: 'vehiclePackagesIndex',
      meta: {
        title: '流量查询',
      },
      component: () => import('@/views/vehiclePackages/index'),
    },
  ],
};
